import { render, staticRenderFns } from "./LinkedGroupModal.vue?vue&type=template&id=381d8465"
import script from "./LinkedGroupModal.vue?vue&type=script&lang=js"
export * from "./LinkedGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports